import {
  Firestore,
  connectFirestoreEmulator,
  getFirestore,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from "firebase/firestore";
import { logError, logMessage } from "shared/services/ErrorReporting";
import { app } from "./app";

const initFirestoreWithCache = (): Firestore => {
  try {
    return initializeFirestore(app, {
      localCache: persistentLocalCache({
        tabManager: persistentMultipleTabManager(),
      }),
    });
  } catch (error) {
    logError(
      new Error(
        "Firestore persistent cache init failed; falling back to memory cache",
        {
          cause: error,
        },
      ),
    );
    return getFirestore(app);
  }
};

export const db: Firestore = initFirestoreWithCache();

const useEmulator = import.meta.env.VITE_USE_FIREBASE_EMULATOR === "true";
if (useEmulator) {
  connectFirestoreEmulator(
    db,
    `${import.meta.env.VITE_FIREBASE_EMULATOR_HOST}`,
    parseInt(import.meta.env.VITE_FIREBASE_EMULATOR_FIRESTORE_PORT, 10),
  );
  logMessage(
    `Firestore emulator connected at ${
      import.meta.env.VITE_FIREBASE_EMULATOR_HOST
    }:${import.meta.env.VITE_FIREBASE_EMULATOR_FIRESTORE_PORT}`,
  );
}
